<template>
  <form ref="formObservation">
    <div class="emd-panel">
      <div class="emd-panel__section">
        <div class="emd-panel__block">
          <div class="el-chunk">
            <h2 class="emd-text _color_default _type_caption">
              {{ $t('title') }}
            </h2>
          </div>
        </div>
        <div class="emd-panel__block">
          <div class="el-chunk">
            <div class="emd-form-group">
              <label
                class="emd-label"
                for="observation"
                >{{ $t('observation-text') }}</label
              >
              <textarea
                class="emd-input"
                type="text"
                cols="30"
                rows="4"
                v-model="form.observation"
                :disabled="disabled"
              >
              </textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import PhysicalWorldFormDTO from '../PhysicalWorldFormDTO'

export default {
  name: 'FormObservation',
  props: {
    initialValues: {
      type: Object
    },
    disabled: {
      type: Boolean
    }
  },
  data () {
    return {
      form: {
        observation: ''
      }
    }
  },
  mounted () {
    this.form = { ...this.form, ...this.initialValues }
  },
  methods: {
    submitEmitter () {
      new PhysicalWorldFormDTO().addItem({
        observation: this.form.observation
      })
    }
  }
}
</script>

<i18n>
      {
          "pt-BR": {
              "title": "Observação",
              "observation-text": "Observações adicionais da solicitação"
          },
          "en-US": {
              "title": "Observation",
              "observation-text": "Additional request notes"
          }
      }
  </i18n>
